import { immer } from 'zustand/middleware/immer'

import { PagePaths } from '~/app/routes'
import { BreadcrumbOption } from '~/astra'
import { readReleaseNoteSeenId } from '~/hooks/useReleaseNote'

import { Slice } from '../store'

type State = {
    activeViews: PagePaths
    breadcrumbs: BreadcrumbOption[]
    isNavSidebarOpen: boolean
    isPrivacyMode: boolean
    isReleaseNoteDialogOpen: boolean
    lastReleaseNoteSeen: number | null
}

const initialState: State = {
    activeViews: {
        PERIODS_OVERVIEW: '/periods-overview',
        ADMIN_PANEL: '/admin-panel/environment-variables',
        DOWNLOAD: '/download',
        MIGRATE: '/migrate',
        SURGERY_SCHEDULER: '/surgery-scheduler',
        OPERATIONAL_PLANNER: '/or-schedule/calendar',
        SURGEON_SCHEDULER: '/surgeon-scheduler/practitioners',
        WAITING_LIST: '/patients/unscheduled',
        RETRO: '/retro',
        INSIGHTS: '/insights/waiting-list',
        HOSPITAL_CONFIGURATION: '/hospital-configuration/surgeons',
    },
    breadcrumbs: [],
    isPrivacyMode: false,
    isNavSidebarOpen: true,
    isReleaseNoteDialogOpen: false,
    lastReleaseNoteSeen: readReleaseNoteSeenId(),
}

type Actions = {
    actions: {
        setActiveViews(activeViews: Partial<State['activeViews']>): void
        setBreadcrumbs(breadcrumbs: State['breadcrumbs']): void
        setIsNavSidebarOpen(isSideBarOpen: State['isNavSidebarOpen']): void
        togglePrivacyMode(): void
        setIsReleaseNotesDialogOpen(isReleaseNotesDialogOpen: State['isReleaseNoteDialogOpen']): void
        setLastReleaseNoteSeen(id: State['lastReleaseNoteSeen']): void
    }
}

export type AppSlice = {
    app: State & Actions
}

export const createAppSlice: Slice<AppSlice> = immer(set => ({
    app: {
        ...initialState,
        actions: {
            setActiveViews(activeViews: Partial<State['activeViews']>) {
                set(state => {
                    state.app.activeViews = { ...state.app.activeViews, ...activeViews }
                })
            },
            setBreadcrumbs(breadcrumbs: State['breadcrumbs']) {
                set(state => {
                    state.app.breadcrumbs = breadcrumbs
                })
            },
            setIsNavSidebarOpen(isSideBarOpen: State['isNavSidebarOpen']) {
                set(state => {
                    state.app.isNavSidebarOpen = isSideBarOpen
                })
            },
            togglePrivacyMode() {
                set(state => {
                    state.app.isPrivacyMode = !state.app.isPrivacyMode
                })
            },
            setIsReleaseNotesDialogOpen(isReleaseNotesDialogOpen: State['isReleaseNoteDialogOpen']) {
                set(state => {
                    state.app.isReleaseNoteDialogOpen = isReleaseNotesDialogOpen
                })
            },
            setLastReleaseNoteSeen(id: State['lastReleaseNoteSeen']) {
                set(state => {
                    state.app.lastReleaseNoteSeen = id
                })
            },
        },
    },
}))
